var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qty-box"},[_c('span',{staticClass:"val"},[_vm._v(_vm._s(_vm.deliveredVal)+" "+_vm._s(_vm.unit))]),_c('span',{staticClass:"small"},[_vm._v(_vm._s(_vm.quantityPerUnit))])])}
var staticRenderFns = []

export { render, staticRenderFns }